import { forwardRef, HTMLAttributes, useRef } from 'react'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'

import SvgIcon from '@/components/base/svg-icon'

import { cn } from '@/lib/utils'

export type ScrollIconProps = HTMLAttributes<HTMLDivElement>

const ScrollIcon = forwardRef<HTMLDivElement, ScrollIconProps>(
  ({ className, ...props }, ref) => {
    const loop = useRef<HTMLSpanElement>(null)

    useGSAP(
      () => {
        gsap.to(loop.current, {
          keyframes: {
            '0%': { scaleY: 0, yPercent: 0 },
            '50%': { scaleY: 1, yPercent: 0, ease: 'power1.inOut' },
            '75%': { scaleY: 1, yPercent: 0 },
            '100%': { scaleY: 0, yPercent: 100, ease: 'power1.inOut' },
            easeEach: 'none'
          },
          transformOrigin: 'top center',
          repeatDelay: 0.2,
          duration: 1.2,
          repeat: -1
        })

        return () => {
          gsap.killTweensOf(loop.current)
        }
      },
      { revertOnUpdate: true }
    )

    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center space-y-[2rem] md:space-y-[3rem]',
          className
        )}
        {...props}
      >
        <SvgIcon
          symbol="star-icon"
          className="h-[3rem] w-[2.8rem] fill-light"
        />
        <span ref={loop} className="relative block h-[6rem] w-[1px] bg-light" />
      </div>
    )
  }
)

export default ScrollIcon
